export default {
  metaTitle: 'Campaign Product Management',
  pageTitle: 'Campaign Product Management',
  applicationMetaTitle: 'Campaign Product Registration',
  submitTime: 'Submission Time',
  placeholder1: 'Campaign Name',
  placeholder2: 'Campaign Code',
  placeholder3: 'Listing#',
  placeholder4: 'Product Name',
  bigpromotionstatus1: 'To be reviewed',
  bigpromotionstatus2: 'To be started',
  bigpromotionstatus3: 'Ongoing',
  bigpromotionstatus4: 'Expired',
  bigpromotionstatus5: 'Cancel or remove or reject',
  passed: 'Passed',
  reject: 'Reject',
  expiredReview: 'Expired without review',
  columns1: 'Listing ID',
  columns2: 'Store ID',
  columns3: 'Title',
  columns4: 'Current campaign price',
  columns5: 'Submission Time',
  columns6: 'Campaign ID',
  columns7: 'Campaign Name',
  columns8: 'Create Time',
  columns9: 'Campaign Code',
  columns10: 'Status',
  columns11: 'Start Time',
  columns12: 'Operation',
  content1: 'Are you sure to proceed with the cancellation operation?',
  success1: 'Successful',
  checkState: 'Audit Status'
}
